<template>
	<main class="mypage signin">
		<div class="siginin_form">
			<h6>아이디 찾기</h6>
			<div class="c_fieldArea">
				<FieldPhoneValidate
					v-model:phoneNum="member_cell"
					v-model:isPhoneValid="member_cell_valid"
					required
					phone-type="Check"
					:phoneNum_error="errors.member_cell"
					:isPhoneValid_error="errors.member_cell_valid"
					type="join"
				/>
				<button class="c_button primary-fill" :disabled="!member_cell || !member_cell_valid" @click="onClickFindId">
					완료
				</button>
			</div>
		</div>
	</main>
</template>

<script setup lang="ts">
// core
import { useRouter } from 'vue-router';
// validation
import { useForm } from 'vee-validate';
import * as yup from 'yup';

// api
import { useFindMemberIdApi } from '@/api/auth';
// component
import FieldPhoneValidate from '@/components/form/FieldPhoneValidate.vue';
// constant
import { phoneRegex } from '@/constants/regex';
// constant
import { ERROR_INVALID_PHONE_NUMBER, ERROR_PHONE_VERIFICATION_REQUIRED, ERROR_REQUIRED_FIELD } from '@/constants/title';
// store
import { useAuthStore } from '@/stores/auth';

// -----variable-----
const authSore = useAuthStore();
const router = useRouter();

// -----validation-----
const {
	errors,
	defineField,
	// handleSubmit,
} = useForm({
	validationSchema: yup.object({
		member_cell: yup
			.string()
			.required(ERROR_REQUIRED_FIELD)
			.min(13, '')
			.matches(phoneRegex, ERROR_INVALID_PHONE_NUMBER),
		member_cell_code: yup.string(),
		member_cell_valid: yup.boolean().isTrue(ERROR_PHONE_VERIFICATION_REQUIRED),
	}),
	initialValues: {
		member_cell: '',
		member_cell_valid: false,
	},
});
const [member_cell] = defineField('member_cell'); //휴대폰번호
const [member_cell_valid] = defineField('member_cell_valid'); // 휴대폰번호 인증 여부

// -----api-----
const { mutateAsync: findMemberId } = useFindMemberIdApi();

// -----function-----
//아이디 찾기(실패, 성공 결과 창 연결)
const onClickFindId = async () => {
	const res = await findMemberId({
		phonenum: member_cell.value.replaceAll('-', ''),
	});
	if (res.data.success) {
		if (!res.data.data.member_id) {
			router.push({ name: 'auth/find-id-result', query: { result: 'false' } });
		} else {
			authSore.setId(res.data.data.member_id.member_id ?? '');
			router.push({
				name: 'auth/find-id-result',
				query: { result: 'true' },
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.signin {
	max-width: 40rem;
	padding-bottom: var(--bottomMenu-height);
	.siginin_form {
		display: flex;
		flex-direction: column;
		width: 100%;
		gap: 4rem;
		.register {
			height: 4.8rem;
			font-size: var(--font-s-regular);
			font-weight: var(--font-w-medium);
		}
		.c_fieldArea {
			.phone_number {
				display: flex;
				flex-direction: column;
				gap: 1rem;
			}
			.c_button {
				height: 4.8rem;
			}
		}
	}
}
</style>
